import {Validators} from '@angular/forms';
import {pre_record_changes_values_4g} from './constants';

import {
    ErrorMessages,
    GenericCameraSettings,
    GroupEnum,
    InputType,
    PhotoSizeEnum,
    PropertyNames,
    RenderType,
    WifiMode,
    WifiModePropertyNames
} from './models';

export const Matrix4GProps: GenericCameraSettings[] = [
    // * Connectivity
    // - Wifi Global Settings
    {
        groupId: GroupEnum.Wi_Fi_Global_Settings,
        orderindex: 1,
        propertyName: PropertyNames.WifiMode[0],
        displayName: PropertyNames.WifiMode[1],
        render: true,
        value: 1,
        defaultValue: 1,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: 'Off', value: 0},
            {text: 'On', value: 1}
        ],
        size: 4,
        effects: [
            {
                propertyNames: WifiModePropertyNames,
                givenValues: [1],
                disabled: false
            },
            {
                propertyNames: WifiModePropertyNames,
                givenValues: [0],
                disabled: true
            },
            {
                givenValues: [1],
                propertyNames: [PropertyNames.WifiConnectionMode[0]],
                value: WifiMode.Station
            },
            {
                givenValues: [],
                propertyNames: [
                    PropertyNames.StreamingResolution[0],
                    PropertyNames.StreamingFrameRate[0],
                    PropertyNames.StreamingBitrate[0],
                    PropertyNames.StreamingControl[0]
                ],
                triggerChange: true
            }
        ]
    },
    {
        groupId: GroupEnum.Wi_Fi_Global_Settings,
        orderindex: 2,
        propertyName: PropertyNames.WifiConnectionMode[0],
        displayName: PropertyNames.WifiConnectionMode[1],
        render: true,
        value: 1,
        defaultValue: WifiMode.Station,
        size: 4,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [{value: WifiMode.Station, text: 'Station'}],
        effects: [
            {
                givenValues: [WifiMode.Station],
                propertyNames: [
                    PropertyNames.Ssid[0],
                    PropertyNames.STPassword[0]
                ],
                disabled: false
            }
        ]
    },
    {
        groupId: GroupEnum.Wi_Fi_Global_Settings,
        orderindex: 3,
        propertyName: PropertyNames.WIFI_ConnectTimeout[0],
        displayName: PropertyNames.WIFI_ConnectTimeout[1],
        render: true,
        value: 0,
        defaultValue: 0,
        size: 4,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: 'Off', value: 0},
            {text: '1 min', value: 1},
            {text: '3 mins', value: 2},
            {text: '5 mins', value: 3},
            {text: '10 mins', value: 4},
            {text: '30 mins', value: 5}
        ],
        tooltip:
            'The body worn camera will stop trying to connect after the selected option to avoid draining the battery'
    },

    // - Network Configuration
    {
        groupId: GroupEnum.Network_Configuration,
        orderindex: 1,
        propertyName: PropertyNames.Ssid[0],
        displayName: PropertyNames.Ssid[1],
        render: true,
        value: '',
        size: 4,
        defaultValue: '',
        inputType: InputType.Text,
        renderType: RenderType.TextBox,
        validations: [Validators.required, Validators.pattern('^[ -~]+$')],
        validationErrorMessages: {
            required: ErrorMessages.Ssid_required,
            pattern: ErrorMessages.Ssid_Pattern
        }
    },
    {
        groupId: GroupEnum.Network_Configuration,
        orderindex: 2,
        propertyName: PropertyNames.STPassword[0],
        displayName: PropertyNames.STPassword[1],
        render: true,
        value: '',
        size: 4,
        defaultValue: '',
        inputType: InputType.Password,
        renderType: RenderType.TextBox,
        validations: [Validators.pattern('^[ -~]{8,32}$')],
        validationErrorMessages: {
            pattern: ErrorMessages.STPassword_Pattern,
            required: ErrorMessages.STPassword_Required
        }
    },

    // - Bluetooth
    {
        groupId: GroupEnum.Bluetooth,
        orderindex: 1,
        propertyName: PropertyNames.BluetoothMode[0],
        displayName: PropertyNames.BluetoothMode[1],
        render: true,
        value: 0,
        defaultValue: 0,
        size: 4,
        inputType: InputType.Boolean,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {value: 0, text: 'Off'},
            {
                value: 1,
                text: 'On',
                tooltip:
                    'Puts the camera in Bluetooth pairing mode enabling pairing with other devices such as a mobile app'
            },
            {
                value: 3,
                text: 'Tait Radio Activation',
                tooltip:
                    'Emergency button press on Tait Radio triggers the recording and optional Livestream("SOSOnRecord": "true" environment setting) on the camera'
            }
        ]
    },

    // - 4G
    {
        groupId: GroupEnum.Four_G,
        orderindex: 1,
        propertyName: PropertyNames.Four_G[0],
        displayName: PropertyNames.Four_G[1],
        render: true,
        value: 0,
        defaultValue: 0,
        size: 4,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: 'Off', value: 0},
            {text: 'Auto', value: 1}
        ],
        effects: [
            {
                givenValues: [],
                propertyNames: [
                    PropertyNames.StreamingResolution[0],
                    PropertyNames.StreamingFrameRate[0],
                    PropertyNames.StreamingBitrate[0],
                    PropertyNames.StreamingControl[0]
                ],
                triggerChange: true
            }
        ]
    },

    // * Camera
    // - Notifications
    {
        groupId: GroupEnum.Notifications,
        orderindex: 1,
        propertyName: PropertyNames.LEDLight[0],
        displayName: PropertyNames.LEDLight[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Toggle
    },
    {
        groupId: GroupEnum.Notifications,
        orderindex: 2,
        propertyName: PropertyNames.ShockReminding[0],
        displayName: PropertyNames.ShockReminding[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Toggle
    },
    {
        groupId: GroupEnum.Notifications,
        orderindex: 3,
        propertyName: PropertyNames.BeepSound[0],
        displayName: PropertyNames.BeepSound[1],
        render: true,
        value: true,
        size: 4,
        defaultValue: true,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: 'Off', value: 0},
            {text: 'Beep', value: 1}
        ]
    },
    {
        groupId: GroupEnum.Notifications,
        orderindex: 4,
        propertyName: PropertyNames.StealthMode[0],
        displayName: PropertyNames.StealthMode[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Toggle,
        tooltip:
            'Long press top recording button to activate Stealth Mode. The LCD screen is also turned off'
    },
    {
        groupId: GroupEnum.Notifications,
        orderindex: 5,
        propertyName: PropertyNames.RecordingNotification[0],
        displayName: PropertyNames.RecordingNotification[1],
        render: true,
        value: true,
        size: 4,
        defaultValue: true,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: 'Off', value: 0},
            {text: 'Beep every 5 secs', value: 1},
            {text: 'Beep every 10 secs', value: 2},
            {text: 'Beep every 15 secs', value: 3},
            {text: 'Beep every 30 secs', value: 4},
            {text: 'Beep every 60 secs', value: 5}
        ]
    },
    {
        groupId: GroupEnum.Notifications,
        orderindex: 6,
        propertyName: PropertyNames.LowBatteryWarning[0],
        displayName: PropertyNames.LowBatteryWarning[1],
        render: true,
        value: 1,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Toggle
    },
    {
        groupId: GroupEnum.Notifications,
        orderindex: 7,
        propertyName: PropertyNames.LowSpaceWarning[0],
        displayName: PropertyNames.LowSpaceWarning[1],
        render: true,
        value: 1,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Toggle
    },

    // - Screen & Keys
    {
        groupId: GroupEnum.Screen_and_Keys,
        orderindex: 1,
        propertyName: PropertyNames.KeyTone[0],
        displayName: PropertyNames.KeyTone[1],
        render: true,
        value: 1,
        size: 4,
        defaultValue: 1,
        inputType: InputType.Number,
        renderType: RenderType.Toggle
    },
    {
        groupId: GroupEnum.Screen_and_Keys,
        orderindex: 2,
        propertyName: PropertyNames.KeyToneVolume[0],
        displayName: PropertyNames.KeyToneVolume[1],
        render: true,
        value: 5,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Slider,
        max: 10,
        min: 0,
        step: 1
    },
    {
        groupId: GroupEnum.Screen_and_Keys,
        orderindex: 3,
        propertyName: PropertyNames.DisplayBrightness[0],
        displayName: PropertyNames.DisplayBrightness[1],
        render: true,
        value: -1,
        size: 4,
        defaultValue: -1,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: 'Auto', value: -1},
            {text: '0', value: 0},
            {text: '1', value: 1},
            {text: '2', value: 2},
            {text: '3', value: 3},
            {text: '4', value: 4},
            {text: '5', value: 5},
            {text: '6', value: 6},
            {text: '7', value: 7},
            {text: '8', value: 8},
            {text: '9', value: 9},
            {text: '10', value: 10}
        ]
    },
    {
        groupId: GroupEnum.Screen_and_Keys,
        orderindex: 4,
        propertyName: PropertyNames.LCDAutoOff[0],
        displayName: PropertyNames.LCDAutoOff[1],
        render: true,
        value: 10,
        size: 4,
        defaultValue: 10,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: '10 secs', value: 1},
            {text: '30 secs', value: 2},
            {text: '1 min', value: 3},
            {text: '3 min', value: 4},
            {text: '5 min', value: 5},
            {text: 'Always On', value: 0}
        ]
    },

    // - Low-light recording
    {
        groupId: GroupEnum.Low_light_recording,
        orderindex: 1,
        propertyName: PropertyNames.IRMode[0],
        displayName: PropertyNames.IRMode[1],
        render: true,
        value: 3,
        size: 4,
        defaultValue: 3,
        inputType: InputType.Text,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: 'Off', value: 0},
            // {text: 'Manual', value: 1},
            {text: 'During recording', value: 2},
            {text: 'Auto', value: 3}
        ]
    },
    {
        groupId: GroupEnum.Low_light_recording,
        orderindex: 2,
        propertyName: PropertyNames.IRCUTSensitivity[0],
        displayName: PropertyNames.IRCUTSensitivity[1],
        render: true,
        value: 5,
        size: 4,
        defaultValue: 5,
        inputType: InputType.Number,
        renderType: RenderType.Slider,
        min: 0,
        max: 10,
        step: 1
    },

    // - GPS
    {
        groupId: GroupEnum.GPS,
        orderindex: 1,
        propertyName: PropertyNames.LocationService[0],
        displayName: PropertyNames.LocationService[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Boolean,
        renderType: RenderType.Toggle
    },
    {
        groupId: GroupEnum.GPS,
        orderindex: 2,
        propertyName: PropertyNames.GPSFrequency[0],
        displayName: PropertyNames.GPSFrequency[1],
        render: true,
        value: 30,
        size: 4,
        defaultValue: 30,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: '15 secs', value: 15},
            {text: '30 secs', value: 30},
            {text: '1 min', value: 60},
            {text: '2 mins', value: 120},
            {text: '5 mins', value: 300}
        ]
    },

    // - Text Overlay
    {
        groupId: GroupEnum.Text_Overlay,
        orderindex: 1,
        propertyName: PropertyNames.EnableWatermark[0],
        displayName: PropertyNames.EnableWatermark[1],
        render: false,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Toggle
    },
    {
        groupId: GroupEnum.Text_Overlay,
        orderindex: 2,
        propertyName: PropertyNames.BurnText[0],
        displayName: PropertyNames.BurnText[1],
        render: true,
        value: '',
        defaultValue: '',
        size: 4,
        inputType: InputType.Text,
        renderType: RenderType.TextBox
    },

    // * Video
    // - Video Format
    {
        groupId: GroupEnum.Video_Format,
        orderindex: 1,
        propertyName: PropertyNames.OutputTV[0],
        displayName: PropertyNames.OutputTV[1], //TV Output
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [{text: 'NTSC', value: 0}]
    },
    {
        groupId: GroupEnum.Video_Format,
        orderindex: 2,
        propertyName: PropertyNames.EncodingFormat[0],
        displayName: PropertyNames.EncodingFormat[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: 'H.264', value: 0},
            {
                text: 'H.265',
                value: 1,
                tooltip:
                    'H.265 live streams require m-View Live Viewer (not supported on web/mobile); Some Windows PCs need codecs for Altitude playback.'
            }
        ],
        effects: [
            {
                givenValues: [],
                propertyNames: [PropertyNames.PreRecordingTime[0]],
                triggerChange: true
            }
        ]
    },

    // - Recording Settings
    {
        groupId: GroupEnum.Recording_Settings,
        orderindex: 1,
        propertyName: PropertyNames.RecordingSize[0],
        displayName: PropertyNames.RecordingSize[1],
        render: true,
        value: 6,
        size: 4,
        defaultValue: 6,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: '2560X1440@30fps', value: 1},
            {text: '1920X1080@60fps', value: 5},
            {text: '1920X1080@30fps', value: 6},
            {text: '1280X720@60fps', value: 10},
            {text: '1280X720@30fps', value: 11},
            {text: '848X480@30fps', value: 13}
        ],
        effects: [
            {
                givenValues: [],
                propertyNames: [PropertyNames.PreRecordingTime[0]],
                triggerChange: true
            }
        ]
    },
    {
        groupId: GroupEnum.Recording_Settings,
        orderindex: 2,
        propertyName: PropertyNames.RecordingQuality[0],
        displayName: PropertyNames.RecordingQuality[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: 'High', value: 0},
            {text: 'Medium', value: 1},
            {text: 'Low', value: 2}
        ],
        effects: [
            {
                givenValues: [],
                propertyNames: [PropertyNames.PreRecordingTime[0]],
                triggerChange: true
            }
        ]
    },
    {
        groupId: GroupEnum.Recording_Settings,
        orderindex: 3,
        propertyName: PropertyNames.RecordingTime[0],
        displayName: PropertyNames.RecordingTime[1],
        render: true,
        value: 4,
        size: 4,
        defaultValue: 4,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: '5 mins', value: 4},
            {text: '10 mins', value: 5},
            {text: '15 mins', value: 6}
        ]
    },
    {
        groupId: GroupEnum.Recording_Settings,
        orderindex: 4,
        propertyName: PropertyNames.VideoMute[0],
        displayName: PropertyNames.VideoMute[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: 'Off', value: 0},
            {text: 'On', value: 1},
            {text: 'Pre-recorded only', value: 2}
        ],
        tooltip: 'Post recording cannot be muted'
    },

    // - Pre and Post Recording
    {
        groupId: GroupEnum.Pre_and_Post_Recording,
        orderindex: 1,
        propertyName: PropertyNames.PreRecordToggle[0],
        displayName: PropertyNames.PreRecordToggle[1],
        render: true,
        value: 1,
        size: 4,
        defaultValue: 1,
        inputType: InputType.Number,
        renderType: RenderType.Toggle,
        effects: [
            {
                givenValues: [0, false],
                propertyNames: [PropertyNames.PreRecordingTime[0]],
                disabled: true,
                value: 0
            },
            {
                givenValues: [1, true],
                propertyNames: [PropertyNames.PreRecordingTime[0]],
                disabled: false
            }
        ]
    },
    {
        groupId: GroupEnum.Pre_and_Post_Recording,
        orderindex: 2,
        propertyName: PropertyNames.PreRecordingTime[0],
        displayName: PropertyNames.PreRecordingTime[1],
        render: true,
        value: 0,
        size: 6,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.CustomSlider,
        customSteps: [
            {
                legend: 0,
                value: 0
            },
            {
                legend: 5,
                value: 1
            },
            {
                legend: 10,
                value: 2
            },
            {
                legend: 15,
                value: 3
            },
            {
                legend: 20,
                value: 4
            },
            {
                legend: 30,
                value: 5
            },
            {
                legend: 60,
                value: 6
            },
            {
                legend: 120,
                value: 7
            }
        ],
        maxSelectable: 30,
        sliderTitleInfo:
            "Recording resolution, video encoding & recording quality selected above influences the pre-record's maximum value",
        changes: {
            propertiesToCheck: [
                PropertyNames.EncodingFormat[0],
                PropertyNames.RecordingSize[0],
                PropertyNames.RecordingQuality[0]
            ],
            propertyNameToChange: 'maxSelectable',
            values: pre_record_changes_values_4g
        }
    },
    {
        groupId: GroupEnum.Pre_and_Post_Recording,
        orderindex: 3,
        propertyName: PropertyNames.PostRecordToggle[0],
        displayName: PropertyNames.PostRecordToggle[1],
        render: true,
        value: 1,
        size: 4,
        defaultValue: 1,
        inputType: InputType.Number,
        renderType: RenderType.Toggle,
        effects: [
            {
                givenValues: [0, false],
                propertyNames: [PropertyNames.PostRecord[0]],
                disabled: true,
                value: 0
            },
            {
                givenValues: [1, true],
                propertyNames: [PropertyNames.PostRecord[0]],
                disabled: false
            }
        ]
    },
    {
        groupId: GroupEnum.Pre_and_Post_Recording,
        orderindex: 4,
        propertyName: PropertyNames.PostRecord[0],
        displayName: PropertyNames.PostRecord[1],
        render: true,
        value: 0,
        size: 5,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.CustomSlider,
        customSteps: [
            {
                legend: 0,
                value: 0
            },
            {
                legend: 5,
                value: 1
            },
            {
                legend: 10,
                value: 2
            },
            // {
            //     legend: 15,
            //     value: 6
            // },
            {
                legend: 20,
                value: 3
            },
            {
                legend: 30,
                value: 4
            },
            {
                legend: 60,
                value: 5
            }
        ],
        maxSelectable: 60
    },

    // - Streaming Setting
    {
        groupId: GroupEnum.Streaming_Settings,
        orderindex: 1,
        propertyName: PropertyNames.StreamingResolution[0],
        displayName: PropertyNames.StreamingResolution[1],
        render: true,
        value: 1,
        size: 4,
        defaultValue: 1,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: '1280X720', value: 1},
            {text: '848X480', value: 2},
            {text: '432X240', value: 3}
        ],
        changes: {
            propertiesToCheck: [
                PropertyNames.WifiMode[0],
                PropertyNames.Four_G[0]
            ],
            propertyNameToChange: 'disabled',
            values: [
                {
                    toCheck: [0, 0],
                    toSet: true
                },
                {
                    toCheck: [0, 1],
                    toSet: false
                },
                {
                    toCheck: [0, 1],
                    toSet: false
                },
                {
                    toCheck: [1, 1],
                    toSet: false
                }
            ]
        }
    },
    {
        groupId: GroupEnum.Streaming_Settings,
        orderindex: 2,
        propertyName: PropertyNames.StreamingFrameRate[0],
        displayName: PropertyNames.StreamingFrameRate[1],
        render: true,
        value: 3,
        size: 4,
        defaultValue: 3,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: '5FPS', value: 0},
            {text: '10FPS', value: 1},
            {text: '15FPS', value: 2},
            {text: '20FPS', value: 3},
            {text: '25FPS', value: 4},
            {text: '30FPS', value: 5}
        ],
        changes: {
            propertiesToCheck: [
                PropertyNames.WifiMode[0],
                PropertyNames.Four_G[0]
            ],
            propertyNameToChange: 'disabled',
            values: [
                {
                    toCheck: [0, 0],
                    toSet: true
                },
                {
                    toCheck: [0, 1],
                    toSet: false
                },
                {
                    toCheck: [0, 1],
                    toSet: false
                },
                {
                    toCheck: [1, 1],
                    toSet: false
                }
            ]
        }
    },
    {
        groupId: GroupEnum.Streaming_Settings,
        orderindex: 3,
        propertyName: PropertyNames.StreamingBitrate[0],
        displayName: PropertyNames.StreamingBitrate[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: '5000 Kbps', value: 0},
            {text: '4000 Kbps', value: 1},
            {text: '3000 Kbps', value: 2},
            {text: '2000 Kbps', value: 3},
            {text: '1000 Kbps', value: 4},
            {text: '500 Kbps', value: 5},
            {text: '300 Kbps', value: 6}
        ],
        changes: {
            propertiesToCheck: [
                PropertyNames.WifiMode[0],
                PropertyNames.Four_G[0]
            ],
            propertyNameToChange: 'disabled',
            values: [
                {
                    toCheck: [0, 0],
                    toSet: true
                },
                {
                    toCheck: [0, 1],
                    toSet: false
                },
                {
                    toCheck: [0, 1],
                    toSet: false
                },
                {
                    toCheck: [1, 1],
                    toSet: false
                }
            ]
        }
    },
    {
        groupId: GroupEnum.Streaming_Settings,
        orderindex: 4,
        propertyName: PropertyNames.StreamingControl[0],
        displayName: PropertyNames.StreamingControl[1],
        render: true,
        value: 3,
        size: 4,
        defaultValue: 3,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: 'Video Only', value: 2},
            {text: 'Audio and video', value: 3}
        ],
        changes: {
            propertiesToCheck: [
                PropertyNames.WifiMode[0],
                PropertyNames.Four_G[0]
            ],
            propertyNameToChange: 'disabled',
            values: [
                {
                    toCheck: [0, 0],
                    toSet: true
                },
                {
                    toCheck: [0, 1],
                    toSet: false
                },
                {
                    toCheck: [0, 1],
                    toSet: false
                },
                {
                    toCheck: [1, 1],
                    toSet: false
                }
            ]
        }
    },

    // - Other Settings
    {
        groupId: GroupEnum.Other_Settings_2,
        orderindex: 1,
        propertyName: PropertyNames.PowerOff[0],
        displayName: PropertyNames.PowerOff[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: 'Off', value: 0},
            // {text: '0 sec', value: 7},
            {text: '30 secs', value: 1},
            {text: '1 min', value: 2},
            {text: '3 mins', value: 3},
            {text: '5 mins', value: 4},
            {text: '10 mins', value: 5},
            {text: '30 mins', value: 6}
        ]
    },
    {
        groupId: GroupEnum.Other_Settings_2,
        orderindex: 2,
        propertyName: PropertyNames.VideoEIS[0],
        displayName: PropertyNames.VideoEIS[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Toggle,
        tooltip: 'Enables image stabilisation and crops video slightly'
    },
    {
        groupId: GroupEnum.Other_Settings_2,
        orderindex: 3,
        propertyName: PropertyNames.DoubleClickRecord[0],
        displayName: PropertyNames.DoubleClickRecord[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Toggle,
        tooltip: 'Double tap on the record button to start and stop recording'
    },
    {
        groupId: GroupEnum.Other_Settings_2,
        orderindex: 4,
        propertyName: PropertyNames.DashCamMode[0],
        displayName: PropertyNames.DashCamMode[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Toggle,
        tooltip:
            "Plug your camera into your vehicle's USB port to turn it into a Dash camera. The camera powers on automatically when connected to power supply"
    },
    {
        groupId: GroupEnum.Other_Settings_2,
        orderindex: 5,
        propertyName: PropertyNames.AutoRecording[0],
        displayName: PropertyNames.AutoRecording[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Toggle,
        tooltip: 'Automatically record when turned on'
    },
    {
        groupId: GroupEnum.Other_Settings_2,
        orderindex: 6,
        propertyName: PropertyNames.AutoDetection[0],
        displayName: PropertyNames.AutoDetection[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Toggle,
        tooltip: 'Starts recording when motion is detected'
    },
    {
        groupId: GroupEnum.Other_Settings_2,
        orderindex: 7,
        propertyName: PropertyNames.LoopRecording[0],
        displayName: PropertyNames.LoopRecording[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Toggle,
        tooltip:
            'Allow old, recorded content to be overwritten if the camera runs out of storage space'
    },

    // * Photo
    // - Image Quality
    {
        groupId: GroupEnum.Image_Quality,
        orderindex: 1,
        propertyName: PropertyNames.PhotoSize[0],
        displayName: PropertyNames.PhotoSize[1],
        render: true,
        value: 4,
        size: 4,
        defaultValue: 4,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: '40 MP', value: PhotoSizeEnum.PHOTO_SIZE_40M},
            {text: '30 MP', value: PhotoSizeEnum.PHOTO_SIZE_30M},
            {text: '16 MP', value: PhotoSizeEnum.PHOTO_SIZE_16M},
            {text: '12 MP', value: PhotoSizeEnum.PHOTO_SIZE_12M},
            {text: '8 MP', value: PhotoSizeEnum.PHOTO_SIZE_8M},
            {text: '4 MP', value: PhotoSizeEnum.PHOTO_SIZE_4M}
        ]
    },

    // - Image Capture
    {
        groupId: GroupEnum.Image_Capture,
        orderindex: 1,
        propertyName: PropertyNames.SelfieTime[0], //Selfie Mode
        displayName: PropertyNames.SelfieTime[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: 'Off', value: 0},
            {text: '3 secs', value: 1},
            {text: '5 secs', value: 2},
            {text: '10 secs', value: 3}
        ]
    },
    {
        groupId: GroupEnum.Image_Capture,
        orderindex: 2,
        propertyName: PropertyNames.BurstMode[0],
        displayName: PropertyNames.BurstMode[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {text: 'Off', value: 0},
            {text: '3 photos every button press', value: 2},
            {text: '5 photos every button press', value: 3}
        ]
    }
];
